import { bindIndividualDetailsPanel } from "../src/rails/individual_details_panel"

jQuery(document).ready(function () {
  bindIndividualDetailsPanel()
  bindVueBillingFilterBar()
})

function createInvoiceParamsManager(initialParams) {
  let invoiceParams = {...initialParams}

  return {
    update(newParams) {
      Object.keys(newParams).forEach(key => {
        if (newParams[key] !== undefined) {
          invoiceParams[key] = newParams[key]
        }
      })
    },
    get(key) {
      return invoiceParams[key]
    },
    getAll() {
      return {...invoiceParams}
    },
  }
}

const invoiceParamsManager = createInvoiceParamsManager({
  transaction_status_filter: '0',
  text_search: '',
  id: '',
  from: '',
  to: '',
})

function bindInvoicesTable() {
  bindInvoiceDropDowns()
  bindSeeMoreInvoices()
  bindPendingToolTips()
}

function bindVueBillingFilterBar() {

  jQuery("#event-bridge-billing-table").off('filters-changed').on('filters-changed', function(e) {
    e.stopPropagation()
    const { text_search, transaction_status_filter, from, to, id } = e.detail

    if (!id) return

    invoiceParamsManager.update({
      text_search,
      transaction_status_filter,
      from,
      to,
      id,
    })

    fetchInvoices()
    jQuery("#invoices_table").removeClass("d-none")
    jQuery(".invoices-container").removeClass("empty-state")
  })
}

function clearTable() {
  jQuery(".invoices-table-body").html("")
  jQuery('.invoices-empty-state').addClass('d-none')
  jQuery("#see_more_btn").addClass("d-none")
}

function fetchInvoices() {
  clearTable()
  buildSkeletonTableRows(jQuery(".invoices-table-body"), {
    rowClass: "group-row skeleton-row",
    floatRight: [2, 3],
    rows: 4,
    columns: 4,
    fade: true,
  })
  const {
    id, 
    transaction_status_filter,
    text_search,
    from,
    to, 
    } = invoiceParamsManager.getAll()
  
  invoicesRequest({id, transaction_status_filter, text_search, from, to})
}

const createInvoicesRequest = () => {
  let request = null
  const invoicesRequest = function(requestData) {
    request = jQuery.ajax({
      url: jQuery(".invoices-container").data("source"),
      type: "GET",
      data: requestData,
      beforeSend: function () {
        if (request != null) {
          request.abort()
        }
      },
      complete: function () {
        request = null
      },
      success: function () {
        jQuery("#invoices_progress_ring").addClass("d-none")
        jQuery("#invoices_progress_ring").html("")
        jQuery(".invoices-container").removeClass("d-none")
        bindInvoicesTable()
      },
    })
  }
  return invoicesRequest
}

const invoicesRequest = createInvoicesRequest()

function rebindInvoicesTable() {
  jQuery("#see_more_btn").unbind("click")
  bindInvoiceDropDowns()
  bindSeeMoreInvoices()
  rebindPendingToolTips()
}

function bindSeeMoreInvoices() {
  jQuery("#see_more_btn").click(function () {
    jQuery(".load-more-text").html(
      '<progress-ring radius="19" progress="0"></progress-ring>',
    )
    animateSeeMoreProgressRing()
    fetchSeeMoreInvoices()
  })
}

const createFetchSeeMoreInvoices = () => {
  let request = null
  const fetchSeeMoreInvoices = function() {
    request = jQuery.ajax({
      url: jQuery("#see_more_btn").data("source"),
      type: "GET",
      beforeSend: function () {
        if (request != null) {
          request.abort()
        }
      },
      complete: function () {
        request = null
      },
      success: function () {
        rebindInvoicesTable()
      },
    })
  }
  return fetchSeeMoreInvoices
}

const fetchSeeMoreInvoices = createFetchSeeMoreInvoices()

function bindInvoiceDropDowns() {
  jQuery('.invoices-container').off('click', ".toggle-drill-down").on('click', ".toggle-drill-down", function (e) {
    if (!jQuery(e.target).hasClass("fa-file-pdf")) {
      var $td = jQuery(this)
      var parent = $td.parent("tr")
      var order_group_id = parent.attr("data-id")
      var drillDownRows = parent.siblings(".drill-down-row-" + order_group_id)
      $td.siblings().find(".hidden-drill-down").toggleClass("d-none")
      $td.siblings().find(".showing-drill-down").toggleClass("d-none")
      $td.find(".hidden-drill-down").toggleClass("d-none")
      $td.find(".showing-drill-down").toggleClass("d-none")
      drillDownRows.toggleClass("d-none")
      parent.toggleClass("active")
      drillDownRows.toggleClass("active")
      if (drillDownRows.first().hasClass('skeleton-order-row')) {
        const {
          id, 
          transaction_status_filter,
          text_search,
          from,
          to, 
          } = invoiceParamsManager.getAll()
        invoicesRequest({id, transaction_status_filter, text_search, from, to, order_group_id})        
      }
    }
  })
}

function bindPendingToolTips() {
  jQuery(".pending-invoice-tooltip").tooltip("enable")

  jQuery("html").click(function (e) {
    if (!jQuery(e.target).hasClass("pending-invoice-tooltip")) {
      jQuery(".pending-invoice-tooltip").tooltip("hide")
    }
  })
}

function rebindPendingToolTips() {
  jQuery(".pending-invoice-tooltip").tooltip("enable")
}

function animateSeeMoreProgressRing() {
  let progress = 0
  const el = document.querySelector(".load-more-text > progress-ring")
  if (el) {
    setInterval(function () {
      progress += 20
      el.setAttribute("progress", progress)
    }, 150)
  }
}

function skeletonCellTemplate(params) {
  const { width = "75%", float = "left", delay = 0, fade = 0 } = params
  return `
    <td>
      <div 
        class="skeleton skeleton-text skeleton-animate-wave skeleton-animate-fade skeleton-delay-${delay} skeleton-fade-${fade}"
        style="width: ${width};
        float: ${float};"
      >
      </div>
    </td>
  `
}

function buildSkeletonTableRows(body, params) {
  const {
    rows = 1,
    columns = 4,
    rowClass = "",
    floatRight = [],
  } = params
  for (let i = 0; i < rows; i++) {
    let row = `<tr id="skeleton-row-${i}" class="${rowClass}" ></tr>`

    body.append(row)
    for (let c = 0; c < columns; c++) {
      let float = floatRight.includes(c) ? "right" : "left"
      let delay = i % 4
      let fade = i % 4
      let cell = skeletonCellTemplate({ float, delay, fade })
      body.find(`#skeleton-row-${i}`).append(cell)
    }
  }
}

window.bindInvoicesTable = bindInvoicesTable
window.rebindInvoicesTable = rebindInvoicesTable
